import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { ReportContext, ReportSessionStatus } from '../../report.models';
import { VehicleFinanceCredentials, VehicleFinanceResponse, VehicleFinanceRow } from './vehicle-finance-report.models';

@Injectable({ providedIn: 'root' })
export class VehicleFinanceReportApiService {
  async load(context: ReportContext, credentials: VehicleFinanceCredentials): Promise<VehicleFinanceResponse> {
    // Both requests must settle before retry is enabled, even if one fails early.
    const requests: Promise<VehicleFinanceRow[] | ReportSessionStatus>[] = [
      context.type === '5' ? Promise.resolve([]) : this.loadRepairs(context, credentials),
      context.type === '4' ? Promise.resolve([]) : this.loadIncome(context, credentials),
    ];
    const settled = await Promise.allSettled(requests);
    for (const result of settled) {
      if (result.status === 'fulfilled' && !Array.isArray(result.value)) return result.value;
    }
    const failure = settled.find(result => result.status === 'rejected');
    if (failure?.status === 'rejected') throw failure.reason;
    const rows = settled.map(result => result.status === 'fulfilled' && Array.isArray(result.value) ? result.value : []);
    return { repairs: rows[0], income: rows[1] };
  }
  private async loadRepairs(context: ReportContext, credentials: VehicleFinanceCredentials): Promise<VehicleFinanceRow[] | ReportSessionStatus> {
    const response = await axios.post(`GetRepairMaintenanceRecordNew?strUnitID=${context.id}&strSDate=${context.startDate}&strEDate=${context.endDate}&strRepairman=&strReason=&strSession=${encodeURIComponent(credentials.repairSession)}&iSystemUser=${credentials.repairUser}`);
    return this.parse(response.data);
  }
  private async loadIncome(context: ReportContext, credentials: VehicleFinanceCredentials): Promise<VehicleFinanceRow[] | ReportSessionStatus> {
    const response = await axios.post('GetCarRvenuessNew', { strUnitID: context.id, strSDate: context.startDate,
      strEDate: context.endDate, strComment: '', iSystemUser: credentials.incomeUser, strSession: credentials.incomeSession });
    return this.parse(response.data);
  }
  private parse(raw: unknown): VehicleFinanceRow[] | ReportSessionStatus {
    const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') {
      const status = data as ReportSessionStatus;
      if (status.ISSessionExpired || status.ISessionExpired) return status;
    }
    throw new Error('Unexpected vehicle finance response');
  }
}
